<div class="balance" [class.profile]="profile">
  <div>
    <span class="label">{{ 'PayWithPoints:ConnectedBalance' | translate }} </span>
    <span *ngIf="points">{{ points | number }}</span>
  </div>
  <div *ngIf="showCurrencyEquivalent">
    <span class="label">{{ 'PayWithPoints:ConnectedCurrency' | translate }} </span>
    <span *ngIf="fiatAmount">{{ fiatAmount | number }} {{ fiatCurrency }}</span>
  </div>
</div>
